export const btn = {
  primary: {
    normal: 'btn btn-primary',
    medium: 'btn btn-primary btn-md',
    small: 'btn btn-primary btn-sm',
    large: 'btn btn-primary btn-lg',
    mini: 'btn btn-primary btn-xs',
  },
  danger: {
    normal: 'btn btn-danger',
    medium: 'btn btn-danger btn-md',
    small: 'btn btn-danger btn-sm',
    large: 'btn btn-danger btn-lg',
    mini: 'btn btn-danger btn-xs',
  },
  success: {
    normal: 'btn btn-success',
    medium: 'btn btn-success btn-md',
    small: 'btn btn-success btn-sm',
    large: 'btn btn-success btn-lg',
    mini: 'btn btn-success btn-xs',
  },
  warning: {
    normal: 'btn btn-warning',
    medium: 'btn btn-warning btn-md',
    small: 'btn btn-warning btn-sm',
    large: 'btn btn-warning btn-lg',
    mini: 'btn btn-warning btn-xs',
  },
  theme: {
    medium: 'btn btn-theme-submit btn-md',
  },
  default: {
    medium: 'btn btn-default btn-md',
  },
};
export const btnOutline = {
  primary: {
    normal: 'btn btn-outline-primary',
    medium: 'btn btn-outline-primary btn-md',
    small: 'btn btn-outline-primary btn-sm',
    large: 'btn btn-outline-primary btn-lg',
    mini: 'btn btn-outline-primary btn-xs',
  },
  danger: {
    normal: 'btn btn-outline-danger',
    medium: 'btn btn-outline-danger btn-md',
    small: 'btn btn-outline-danger btn-sm',
    large: 'btn btn-outline-danger btn-lg',
    mini: 'btn btn-outline-danger btn-xs',
  },
  success: {
    normal: 'btn btn-outline-success',
    medium: 'btn btn-outline-success btn-md',
    small: 'btn btn-outline-success btn-sm',
    large: 'btn btn-outline-success btn-lg',
    mini: 'btn btn-outline-success btn-xs',
  },
  warning: {
    normal: 'btn btn-outline-warning',
    medium: 'btn btn-outline-warning btn-md',
    small: 'btn btn-outline-warning btn-sm',
    large: 'btn btn-outline-warning btn-lg',
    mini: 'btn btn-outline-warning btn-xs',
  },
  theme: {},
};
